//converts Persian and Arabic numerals in a string to their corresponding English numerals.
export const fixNumbers = function (str) {
    const persianNumbers = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
    const arabicNumbers = ["٠", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"];
    const englishNumbers = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"];

    return str?.replace(/[۰-۹٠-٩]/g, char => {
        const persianIndex = persianNumbers.indexOf(char);
        if (persianIndex > -1) return englishNumbers[persianIndex];

        const arabicIndex = arabicNumbers.indexOf(char);
        if (arabicIndex > -1) return englishNumbers[arabicIndex];

        return char;
    });
};

//format a number by adding commas as thousands separators
export function numberWithCommas(number) {
    if (!number) return 0;
    number = number?.toString();
    var regexPattern = /(-?\d+)(\d{3})/;
    while (regexPattern.test(number)) number = number?.replace(regexPattern, "$1,$2");
    return number;
}

//scrolls the window to a specified position
export function scrollToPosition({ top = 0, left = 0, behavior = "smooth" } = {}) {
    window.scrollTo({ top, left, behavior });
}

// A debouncer function that limits the rate at which a function can fire.
export function debouncer(callBack, delay = 1000) {
    let timer;
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => {
            callBack.apply(this, args);
        }, delay);
    };
}

//calculates the discount percentage
export function calculateDiscountPercent(originalPrice, discountedPrice) {
    if (originalPrice <= 0 || discountedPrice < 0) return;

    if (discountedPrice >= originalPrice) {
        return "0%";
    }

    const discount = originalPrice - discountedPrice;
    const percentage = (discount / originalPrice) * 100;
    return Math.round(percentage) + "%";
}

//navigate to the sign-in page
export function navigateToLoginPage(navigate, locale, location) {
    navigate(
        {
            pathname: `/${locale}/login`,
        },
        { state: { from: location }, replace: true },
    );
}

export const maskCardNumber = cardNumber => {
    const masked = cardNumber.replace(/^(\d{4})\d{8}(\d{4})$/, "$1****$2");
    return `\u200E${masked}`;
};

//۰۹۳۵۸۲۴۴۷۲۵
//zohreh_bodaghi۷۳@yahoo.com
